import styled from 'styled-components';
import ArrowTailDownIconSvg from './arrow-tail-down.svg';

const ArrowTailDownIcon = styled(ArrowTailDownIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default ArrowTailDownIcon;

